import React from 'react'
import { useFindDatasourceConfiguration } from 'src/api/queries/microservices/platform-markets-stonex-config'
import TenantConfigPanel from 'src/companies/configurations/tenant'
import { Button, ChevronDownIcon, Menu, MenuButton, MenuItem, MenuList, Stack } from 'src/ui'
import StoneXConfigPanel from './stonex-config-panel'

export default function PlatformMarketsConfig() {
  const { data: stoneXConfig, isLoading: isStoneXConfigLoading } = useFindDatasourceConfiguration()
  const [showStoneXConfig, setShowStoneXConfig] = React.useState(false)

  const hasExistingStoneXConfig = stoneXConfig !== null && stoneXConfig !== undefined

  const areProviderConfigsLoading = isStoneXConfigLoading

  return (
    <Stack spacing={4}>
      <TenantConfigPanel baseUri="/api/platform/markets/config/v1" title="Tenant" alwaysExpanded />

      {!hasExistingStoneXConfig && (
        <Menu placement="bottom-start">
          <MenuButton
            as={Button}
            rightIcon={<ChevronDownIcon />}
            alignSelf="flex-start"
            isDisabled={areProviderConfigsLoading}
            isLoading={areProviderConfigsLoading}
          >
            Configure new provider
          </MenuButton>
          <MenuList>
            <MenuItem onClick={() => setShowStoneXConfig(true)} textTransform="none">
              StoneX
            </MenuItem>
          </MenuList>
        </Menu>
      )}

      {(hasExistingStoneXConfig || showStoneXConfig) && (
        <StoneXConfigPanel
          data={stoneXConfig ?? []}
          isExistingConfig={hasExistingStoneXConfig}
          onClose={() => {
            setShowStoneXConfig(false)
          }}
        />
      )}
    </Stack>
  )
}
